// frontend/src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// TODO: Replace with your actual Firebase config
// Get from Firebase Console → Project Settings
const firebaseConfig = {
  apiKey: "AIzaSyDQG6rmP5kk4HHUxriOnzUIzsS7ZmLEaok",
  authDomain: "bikini-world-87694.firebaseapp.com",
  projectId:  "bikini-world-87694",
  storageBucket: "bikini-world-87694.firebasestorage.app",
  messagingSenderId: "810149331322",
  appId: "1:810149331322:web:0a45a5b50c66e39f1956c3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };